import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'

export const INPUT_TYPES = [
  { value: 'text', name: 'input.type.text' },
  { value: 'number', name: 'input.type.number' },
  { value: 'email', name: 'input.type.email' },
  { value: 'tel', name: 'input.type.tel' },
  { value: 'url', name: 'input.type.url' },
]

export const DEFAULT_INPUT_TYPE = 'text'

export const defaultText = {
  question: 'Write your question here...',
  helpText: ' ',
}

export const defaultSettings = {
  type: BLOCK_TYPES.FIELD,
  fieldType: FIELD_TYPES.SHORT_TEXT,
  question: defaultText.question,
  isRequired: false,
  hasHelpText: false,
  helpText: defaultText.helpText,
  inputType: DEFAULT_INPUT_TYPE,
}
